






















import { computed, defineComponent, toRefs } from '@vue/composition-api';
import { PropType } from 'vue';
import { VIDEO_ACTIONS } from '@tt4b/ttam-enums';

const name = 'ttam-behavior-video-actions';
export default defineComponent({
  model: {
    prop: 'selectedActions',
    event: 'change',
  },
  props: {
    selectedActions: {
      type: Array as PropType<Array<number>>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const { selectedActions } = toRefs(props);

    const _selectedActions = computed({
      get: () => selectedActions.value,
      set: val => {
        emit('change', val);
      },
    });
    return {
      VIDEO_ACTIONS,
      name,
      _selectedActions,
    };
  },
});
